import React from "react";
import { IconsType } from "../../../libs/Utils/types";
import s from "./Camera.module.scss";
import clsx from "clsx";
type CameraProp = IconsType & {
  onClick: () => void;
};
function Camera({ onClick, fill, height, width }: CameraProp) {
  return (
    <div onClick={onClick} className={clsx(!width && s.wrapper)}>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: width || "100%",
          height: height || "100%",
        }}
        preserveAspectRatio="xMidYMid meet"
      >
        <rect
          x="0.8"
          y="0.8"
          width="30.4"
          height="30.4"
          rx="15.2"
          fill="#6A6767"
        />
        <rect
          x="0.8"
          y="0.8"
          width="30.4"
          height="30.4"
          rx="15.2"
          stroke="white"
          stroke-width="1.6"
        />
        <path
          d="M16 14.4002C14.6745 14.4002 13.6 15.4747 13.6 16.8002C13.6 18.1257 14.6745 19.2002 16 19.2002C17.3255 19.2002 18.4 18.1257 18.4 16.8002C18.4 15.4747 17.3255 14.4002 16 14.4002Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.5941 9.2002H17.4059C18.0424 9.2002 18.6529 9.45305 19.1029 9.90314L19.6517 10.4519C19.8815 10.6817 20.1556 10.8624 20.4574 10.9831L22.4913 11.7967C23.4025 12.1612 24 13.0437 24 14.0251V20.4002C24 21.7257 22.9255 22.8002 21.6 22.8002H10.4C9.07452 22.8002 8 21.7257 8 20.4002V14.0251C8 13.0437 8.59748 12.1612 9.50866 11.7967L11.5426 10.9831C11.8444 10.8624 12.1185 10.6817 12.3483 10.4519L12.8971 9.90314C13.3471 9.45305 13.9576 9.2002 14.5941 9.2002ZM12 16.8002C12 14.5911 13.7909 12.8002 16 12.8002C18.2091 12.8002 20 14.5911 20 16.8002C20 19.0093 18.2091 20.8002 16 20.8002C13.7909 20.8002 12 19.0093 12 16.8002ZM19.0781 13.7541C19.3988 13.861 19.6505 14.1126 19.7574 14.4334C19.8662 14.7598 20.3279 14.7598 20.4367 14.4334C20.5436 14.1126 20.7953 13.861 21.116 13.7541C21.4424 13.6453 21.4424 13.1836 21.116 13.0748C20.7953 12.9679 20.5436 12.7162 20.4367 12.3955C20.3279 12.0691 19.8662 12.0691 19.7574 12.3955C19.6505 12.7162 19.3988 12.9679 19.0781 13.0748C18.7517 13.1836 18.7517 13.6453 19.0781 13.7541Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default Camera;
